import api from '@/api'

export default {
	data () {
		return {
			states: []
		}
	},

	mounted () {
		this.getStates()
	},

	methods: {
		getStates () {
			const method = 'GET'
			const data = {}

			const url = this.route('states.api')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.states = response.data
			})
		},

		getState (stateId) {
			if (! this.states) {
				return 'Unknown'
			}

			const state = _.find(this.states, { id: parseInt(stateId) })

			if (state) {
				return state['code']
			}
		}
	}
}
